import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format } from "date-fns";
import _ from "lodash";

import {
  Badge,
  Checkbox,
  Labeled,
  Input,
  Button,
  ButtonComposed,
  itemList,
} from "@lifepay/rc-ui-toolkit";

import { hasPrivileges } from "utils";

import styles from "./User.m.scss";

import { ssoUserRole } from "model/gql/mutations";
const AddUserRole = itemList.MutationFactory(ssoUserRole.add);
const EditUserRole = itemList.MutationFactory(ssoUserRole.edit);

const ROLES = {
  callcenter: {
    label: "Коллцентер",
    isAdminKeyNames: ["callcenter.isAdmin"],
    isSuperAdminKeyNames: ["callcenter.isSuperAdmin"],
    privileges: {
      isSuperAdmin: {
        label: "Суперадмин",
        type: "superadmin",
      },
      isAdmin: {
        label: "Админ",
        type: "admin",
      },
      oktellUserName: {
        label: "Имя пользователя oktell",
        type: "value",
      },
      acquiring: {
        label: "Работа с юр. лицами",
        type: "bool",
      },
      emission: {
        label: "Работа с физ. лицами",
        type: "bool",
      },
      // changeClientEmail: {
      //   label: "Изменение email адреса клиента",
      //   type: "bool",
      // },
      cards: {
        label: "Просмотр карточных данных",
        type: "bool",
      },
      blockCard: {
        label: "Блокировка карт",
        type: "bool",
      },
      activateCard: {
        label: "Разблокировка карт",
        type: "bool",
      },
      setCardForPinChange: {
        label: "Смена пинкода",
        type: "bool",
      },
      resetCardPinCounter: {
        label: "Сброс счетчика неверных попыток ввода пинкода",
        type: "bool",
      },
      changeCardNotificationStatus: {
        label: "Включение/выключение sms информирования",
        type: "bool",
      },
      changeCardPhone: {
        label: "Изменение телефона по карте",
        type: "bool",
      },
      cardLimits: {
        label: "Просмотр лимитов по картам",
        type: "bool",
      },
      changeCardLimits: {
        label: "Изменение лимитов по картам",
        type: "bool",
      },
      cardTransactions: {
        label: "Просмотр транзакций по картам",
        type: "bool",
      },
    },
  },
  processing: {
    label: "Процессинг",
    isAdminKeyNames: ["processing.isAdmin"],
    isSuperAdminKeyNames: ["processing.isSuperAdmin"],
    privileges: {
      isSuperAdmin: {
        label: "Суперадмин",
        type: "superadmin",
      },
      isAdmin: {
        label: "Админ",
        type: "admin",
      },
      processingUserName: {
        label: "Имя пользователя в процессинге",
        type: "value",
      },
      ssoUsers: {
        label: "Просмотр списка пользователей sso",
        type: "bool",
      },
      createSsoUsers: {
        label: "Создание пользователей sso",
        type: "bool",
      },
      processingUsers: {
        label: "Просмотр списка пользователей, ролей и доступов процессинга",
        type: "bool",
      },
      createProcessingUsers: {
        label: "Создание пользователей процессинга",
        type: "bool",
      },
      deleteProcessingUsers: {
        label: "Удаление пользователей процессинга",
        type: "bool",
      },
      blockProcessingUsers: {
        label: "Блокировка пользователей процессинга",
        type: "bool",
      },
      changeProcessingUserRoles: {
        label: "Изменение ролей пользователей процессинга",
        type: "bool",
      },
      changeProcessingUserAccess: {
        label: "Изменение доступов пользователей процессинга",
        type: "bool",
      },
      companies: {
        label: "Просмотр компаний",
        type: "bool",
      },
      merchants: {
        label: "Просмотр точек обслуживания",
        type: "bool",
      },
      terminals: {
        label: "Просмотр терминалов",
        type: "bool",
      },
      transactions: {
        label: "Просмотр транзакций",
        type: "bool",
      },
    },
  },
  serviceDesk: {
    label: "Сервисдеск",
    isAdminKeyNames: ["serviceDesk.isAdmin"],
    isSuperAdminKeyNames: ["serviceDesk.isSuperAdmin"],
    privileges: {
      isSuperAdmin: {
        label: "Суперадмин",
        type: "superadmin",
      },
      isAdmin: {
        label: "Админ",
        type: "admin",
      },
      serviceDeskUserName: {
        label: "Имя пользователя service desk",
        type: "value",
      },
    },
  },
};

@themr("@lifepay/User", styles)
export default class User extends Component {
  static displayName = "User";

  static propTypes = {
    theme: PropTypes.object,
    item: PropTypes.object,
    currentUserRoles: PropTypes.object,
    extendedView: PropTypes.bool,
    updateQuery: PropTypes.func,
  };

  static defaultProps = {
    extendedView: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      newRoles: null,
      submitButtonState: "normal",
    };
  }

  setNewRoles = ({ value, id }) => {
    const role = id.split(".")[0];
    this.setState((prevState) => ({
      newRoles: {
        ...prevState.newRoles,
        [role]: true,
        [id]: value,
      },
    }));
  };

  handleRoleChange = ({ value, id, oldRoles }) => {
    const role = id;
    if (!oldRoles[role]) {
      this.setState((prevState) => {
        const newState = {
          newRoles: {
            ...prevState.newRoles,
            [role]: value,
          },
        };
        if (!value) {
          delete newState.newRoles[role];
        }
        return newState;
      });
    }
  };

  submitChanges = ({ addUserRole, changeUserRole, oldRoles }) => {
    const { newRoles } = this.state;
    const { item, updateQuery } = this.props;
    const roles = {};
    Object.keys(newRoles).forEach((key) => {
      const path = key.split(".");
      const value = newRoles[key];
      const role = path[0];
      const privilege = path[1];
      if (!roles[role]) {
        roles[role] = {};
      }
      if (privilege) {
        roles[role][privilege] = value;
      }
    });
    const mutations = [];
    const changes = Object.keys(roles);

    if (changes.length) {
      this.setState({ submitButtonState: "loading" });
    }
    changes.forEach((role) => {
      const privileges = roles[role];
      if (oldRoles[role]) {
        mutations.push(
          changeUserRole({
            variables: {
              roleId: oldRoles[role].id,
              roleName: oldRoles[role].name,
              data: JSON.stringify(privileges),
            },
            update: (cache, { data: { changeUserRole } }) => {
              updateQuery((prevUsers) => {
                if (changeUserRole && prevUsers && prevUsers.ssoUsers) {
                  const newUsers = prevUsers.ssoUsers.slice();
                  const index = _.findIndex(newUsers, {
                    id: changeUserRole.user,
                  });
                  const oldUser = newUsers[index];
                  const roleIndex = _.findIndex(oldUser.roles, {
                    id: changeUserRole.id,
                  });
                  const newRoles = oldUser.roles.slice();
                  newRoles.splice(roleIndex, 1, {
                    ...oldUser.roles[roleIndex],
                    id: changeUserRole.id,
                    name: changeUserRole.name,
                    data: changeUserRole.data,
                  });
                  newUsers.splice(index, 1, {
                    ...oldUser,
                    roles: newRoles,
                  });
                  return {
                    ...prevUsers,
                    ssoUsers: newUsers,
                  };
                }
              });
            },
          })
        );
      } else {
        mutations.push(
          addUserRole({
            variables: {
              roleName: role,
              userId: item.id,
              data: JSON.stringify(privileges),
            },
            update: (cache, { data: { addUserRole } }) => {
              updateQuery((prevUsers) => {
                if (addUserRole && prevUsers && prevUsers.ssoUsers) {
                  const newUsers = prevUsers.ssoUsers.slice();
                  const index = _.findIndex(newUsers, {
                    id: addUserRole.userId,
                  });
                  const oldUser = newUsers[index];
                  const newRoles = oldUser.roles.slice();
                  newRoles.push({
                    id: addUserRole.id,
                    name: addUserRole.roleName,
                    data: addUserRole.data,
                    __typename: "SsoRole",
                  });
                  newUsers.splice(index, 1, {
                    ...oldUser,
                    roles: newRoles,
                  });
                  return {
                    ...prevUsers,
                    ssoUsers: newUsers,
                  };
                }
              });
            },
          })
        );
      }
    });

    Promise.all(mutations)
      .then(() => {
        this.setState({ newRoles: null, submitButtonState: "normal" });
      })
      .catch(() => {
        this.setState({ submitButtonState: "error" });
      });
  };

  clearChanges = () => {
    this.setState({ newRoles: null, submitButtonState: "normal" });
  };

  render() {
    const { theme, item, currentUserRoles, extendedView } = this.props;
    const { newRoles, submitButtonState } = this.state;

    const dateJoined = item.dateJoined
      ? format(item.dateJoined, "YYYY-MM-DD HH:mm:ss")
      : "-";

    const lastLogin = item.lastLogin
      ? format(item.lastLogin, "YYYY-MM-DD HH:mm:ss")
      : "-";

    const roles = item.roles;

    const parsedRoles = {};

    roles.forEach((role) => {
      if (ROLES[role.name]) {
        parsedRoles[role.name] = {
          ...role,
          data: JSON.parse(role.data),
        };
      }
    });

    return (
      <AddUserRole>
        {(addUserRole) => (
          <EditUserRole>
            {(changeUserRole) => (
              <div className={classnames(theme.wrapper)}>
                <div className={classnames(theme.summary)}>
                  <Labeled label={"Id"}>{item.id || "-"}</Labeled>
                  <Labeled label={"Статус"}>
                    <Badge type={item.isActive ? "green" : "red"}>
                      {item.isActive ? "Активен" : `Заблокирован`}
                    </Badge>
                  </Labeled>
                  <Labeled label={"Логин"}>{item.username || "-"}</Labeled>
                  <Labeled label={"Имя"}>{item.firstName || "-"}</Labeled>
                  <Labeled label={"Фамилия"}>{item.lastName || "-"}</Labeled>
                  <Labeled label={"Email"}>{item.email || "-"}</Labeled>
                </div>
                {extendedView && (
                  <div className={classnames(theme.extended)}>
                    <div className={classnames(theme.roles)}>
                      {Object.keys(ROLES).map((roleKey) => {
                        const role = ROLES[roleKey];
                        const roleValue =
                          parsedRoles[roleKey] && parsedRoles[roleKey].data;
                        const operatorIsRoleAdmin = hasPrivileges(
                          currentUserRoles,
                          role.isAdminKeyNames
                        );
                        const operatorIsRoleSuperAdmin = hasPrivileges(
                          currentUserRoles,
                          role.isSuperAdminKeyNames,
                          false
                        );
                        const userIsRoleAdmin = hasPrivileges(
                          parsedRoles,
                          role.isAdminKeyNames,
                          false
                        );
                        const roleEditEnabled =
                          operatorIsRoleSuperAdmin ||
                          (operatorIsRoleAdmin && !userIsRoleAdmin);
                        const roleCurrentValue =
                          newRoles && newRoles[`${roleKey}`] !== undefined
                            ? newRoles[`${roleKey}`]
                            : !!roleValue;
                        return (
                          <div key={roleKey} className={classnames(theme.role)}>
                            <div className={classnames(theme.header)}>
                              <Checkbox
                                name={"user_" + item.id}
                                id={roleKey}
                                checked={!!roleCurrentValue}
                                disabled={!roleEditEnabled}
                                onChange={({ id, value }) =>
                                  this.handleRoleChange({
                                    id,
                                    value,
                                    oldRoles: parsedRoles,
                                  })
                                }
                              >
                                {role.label}
                              </Checkbox>
                            </div>
                            <div className={classnames(theme.privileges)}>
                              {role.privileges &&
                                Object.keys(role.privileges).map(
                                  (privilegeKey) => {
                                    const privilege =
                                      role.privileges[privilegeKey];
                                    const privilegeValue = roleValue
                                      ? roleValue[privilegeKey]
                                      : false;
                                    const isInAdminScope =
                                      operatorIsRoleAdmin &&
                                      hasPrivileges(
                                        currentUserRoles,
                                        `${roleKey}.${privilegeKey}`
                                      );
                                    const privilegeEditEnabled =
                                      operatorIsRoleSuperAdmin ||
                                      (roleEditEnabled &&
                                        isInAdminScope &&
                                        !userIsRoleAdmin);
                                    const value =
                                      newRoles &&
                                      newRoles[`${roleKey}.${privilegeKey}`] !==
                                        undefined
                                        ? newRoles[`${roleKey}.${privilegeKey}`]
                                        : !!privilegeValue;
                                    switch (privilege.type) {
                                      case "bool": {
                                        return (
                                          <Checkbox
                                            name={"user_" + item.id}
                                            id={`${roleKey}.${privilegeKey}`}
                                            key={privilegeKey}
                                            disabled={!privilegeEditEnabled}
                                            checked={value}
                                            onChange={this.setNewRoles}
                                          >
                                            {privilege.label}
                                          </Checkbox>
                                        );
                                      }
                                      case "value": {
                                        if (privilegeEditEnabled) {
                                          return (
                                            <Input
                                              name={"user_" + item.id}
                                              id={`${roleKey}.${privilegeKey}`}
                                              key={privilegeKey}
                                              label={true}
                                              initialValue={
                                                privilegeValue || ""
                                              }
                                              onChange={this.setNewRoles}
                                            >
                                              {privilege.label}
                                            </Input>
                                          );
                                        } else {
                                          return (
                                            <Labeled
                                              key={privilegeKey}
                                              label={privilege.label}
                                            >
                                              {privilegeValue || "-"}
                                            </Labeled>
                                          );
                                        }
                                      }
                                      case "admin": {
                                        return (
                                          <Checkbox
                                            name={"user_" + item.id}
                                            id={`${roleKey}.${privilegeKey}`}
                                            key={privilegeKey}
                                            disabled={!operatorIsRoleSuperAdmin}
                                            checked={value}
                                            onChange={this.setNewRoles}
                                          >
                                            {privilege.label}
                                          </Checkbox>
                                        );
                                      }
                                      case "superadmin": {
                                        return operatorIsRoleSuperAdmin ? (
                                          <Checkbox
                                            name={"user_" + item.id}
                                            id={`${roleKey}.${privilegeKey}`}
                                            key={privilegeKey}
                                            checked={value}
                                            onChange={this.setNewRoles}
                                          >
                                            {privilege.label}
                                          </Checkbox>
                                        ) : null;
                                      }
                                      default: {
                                        return null;
                                      }
                                    }
                                  }
                                )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className={classnames(theme.extra)}>
                      <div className={classnames(theme.controls)}>
                        {newRoles && (
                          <React.Fragment>
                            <ButtonComposed
                              state={submitButtonState}
                              disabled={submitButtonState !== "normal"}
                              type={"main"}
                              size={"small"}
                              theme={{
                                wrapper: theme.button,
                              }}
                              onClick={() =>
                                this.submitChanges({
                                  addUserRole,
                                  changeUserRole,
                                  oldRoles: parsedRoles,
                                })
                              }
                            >
                              {"Подтвердить"}
                            </ButtonComposed>
                            <Button
                              type={"alt"}
                              size={"small"}
                              onClick={this.clearChanges}
                            >
                              {"Отмена"}
                            </Button>
                          </React.Fragment>
                        )}
                      </div>
                      <div className={classnames(theme.dates)}>
                        <div className={classnames(theme.date)}>
                          <div className={classnames(theme.label)}>
                            {"Дата создания"}
                          </div>
                          <div className={classnames(theme.value)}>
                            {dateJoined}
                          </div>
                        </div>
                        <div className={classnames(theme.date)}>
                          <div className={classnames(theme.label)}>
                            {"Последняя активность"}
                          </div>
                          <div className={classnames(theme.value)}>
                            {lastLogin}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </EditUserRole>
        )}
      </AddUserRole>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list-items/User/User.js